import type { FC } from 'react';
import ReactCards from 'react-credit-cards-2';
import { useFormContext } from 'react-hook-form';

import privacyIcon from '@/modules/perseo-billing/assets/images/privacy.png';
import { EComponentType } from '@/modules/perseo-billing/interfaces//src/bff-web/billing';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

import type { TPaymentMethod } from '../../containers/payment-methods/interfaces';
import type { TCardInputs } from '../../interfaces';
import { PaymentProcessor } from '../../interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';

import './style.scss';

type TInputNames = 'number' | 'name' | 'expiry' | 'cvc' | null | undefined;

interface IPreviewSavedCard extends Partial<TPaymentMethod> {
  focusedInput?: TCardInputs | null;
}

export const PreviewSavedCard: FC<IPreviewSavedCard> = (props) => {
  const { lastDigits, isExpired, focusedInput, processorId, brand } =
    props || {};

  const { watch } = useFormContext();
  const cardNumberWatch = watch('cardNumber') || '';
  const cardExpiry = watch('expiry') || '';
  const cardCvv = watch('cvv') || '';
  const maskedCvv = cardCvv.replace(/\d/g, '*');
  const cardHolder = watch('name') || '';

  const isCencosudCard =
    processorId === PaymentProcessor.TRANSBANK_CENCOSUD_CARD;

  const cardNumber = lastDigits
    ? '**** **** **** ' + lastDigits
    : cardNumberWatch || '';

  const getFocus = (focusedInput: TCardInputs | null): TInputNames => {
    if (focusedInput === 'cardNumber') return 'number';
    if (focusedInput === 'cvv') return 'cvc';
    return focusedInput;
  };

  const isSavedCard = processorId === EComponentType.SAVED_CARD;
  const focusedInputName = getFocus(focusedInput);

  return (
    <div
      className={`co-flex co-flex-col co-bg-back-gray co-rounded-8px co-w-full co-p-16px co-gap-24px ${
        isCencosudCard ? 'cencosud-card' : ''
      } ${isSavedCard ? 'saved-card' : ''} ${isExpired ? 'expired-card' : ''}`}
    >
      <ReactCards
        number={cardNumber}
        expiry={cardExpiry}
        cvc={maskedCvv}
        name={cardHolder}
        issuer={brand || ''}
        focused={focusedInputName || ''}
        acceptedCards={['visa', 'mastercard', 'american-express', 'dinersclub']}
        placeholders={
          {
            name: 'NOMBRE APELLIDO',
            number: '**** **** **** ****',
            expiry: 'MM / AA'
          } as { name: string }
        }
        locale={{
          valid: ''
        }}
        preview
      />
      <div className="co-flex co-items-center co-justify-center co-gap-8px">
        <div className="co-object-contain">
          <img src={privacyIcon} alt={'product'} width={24} height={24} />
        </div>
        <Typography size="body2" weight="medium">
          Tu información está segura con nosotros
        </Typography>
      </div>
    </div>
  );
};
